import type { Mode } from '../config/types'
import { ENV } from '../utils/env'

type ModeSelectorProps = {
    mode: Mode
    triggerSpellcheck: () => void
    triggerParaphrase: () => void
}

type ModeButtonProps = {
    text: string
    icon: string
    cssClass: string
    current: boolean
    action: () => void
}

export const ModeSelector = ({ mode, triggerParaphrase, triggerSpellcheck }: ModeSelectorProps) => {

    if (ENV.PARAPHRASE_DISABLED) return <></>

    return (
        <ul id="mode-selector" className="nav nav-tabs">
            <ModeButton action={triggerSpellcheck} current={mode == "SpellCheck"} text="Corregeix" icon="fas fa-spell-check" cssClass="spell-checker-button" />
            <ModeButton action={triggerParaphrase} current={mode == "Paraphrase"} text="Parafraseja" icon="fas fa-parachute-box" cssClass="paraphrase-button" />
        </ul>
    )
}

function ModeButton({ text, icon, cssClass, current, action } : ModeButtonProps) {

    return (
        <li className={ current ? 'active' : ''}>
            <a
                className={cssClass}
                onClick={(e) => {
                    action()
                    e.preventDefault()
                }}
            >
                <i className={icon}></i>
                {text}
            </a>
        </li>
    )
}

